import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysIframeComponent } from './genesys-iframe.component';



@NgModule({
  declarations: [
    GenesysIframeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GenesysIframeComponent
  ]
})
export class GenesysIframeModule { }
